import React, { Component } from "react";
import Footer from "./Footer";
import "./Home.css";
import Chatio from "./Chatio"; // Rename the component to Chat
class chat extends Component{
  render(){
    return(
      <div className="mentoring-chat">
          <div className ="homeContainer row">
            <Chatio />
            <Footer />
        </div>
      </div>
    )
  }
}
export default chat;
